import { render, staticRenderFns } from "./VersionListItem.vue?vue&type=template&id=5a19dd5a"
import script from "./VersionListItem.vue?vue&type=script&lang=js"
export * from "./VersionListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports